import { createParser, system } from "../core";
import { t } from "../utils";
import { transformGradient } from "../utils/parse-gradient";

function transformBgClip(value) {
  return value === "text" ? {
    WebkitTextFillColor: "transparent",
    backgroundClip: "text"
  } : {
    backgroundClip: value
  };
}

var config = {
  bg: t.colors("background"),
  bgColor: t.colors("backgroundColor"),
  background: t.colors("background"),
  backgroundColor: t.colors("backgroundColor"),
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundBlendMode: true,
  backgroundClip: {
    property: "&",
    transform: transformBgClip
  },
  bgImage: t.prop("backgroundImage"),
  bgImg: t.prop("backgroundImage"),
  bgBlendMode: t.prop("backgroundBlendMode"),
  bgSize: t.prop("backgroundSize"),
  bgPosition: t.prop("backgroundPosition"),
  bgPos: t.prop("backgroundPosition"),
  bgRepeat: t.prop("backgroundRepeat"),
  bgAttachment: t.prop("backgroundAttachment"),
  bgGradient: {
    property: "backgroundImage",
    transform: transformGradient
  },
  bgClip: {
    property: "&",
    transform: transformBgClip
  }
};
export var background = system(config);
export var backgroundParser = createParser(config);